import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import { useParams } from 'react-router-dom'
import { Client, Identifier, getMsApiToken } from 'utils'

import { Loading } from './Loading'
import { Denied } from './Denied'

const { REACT_APP_MICROSERVICES_DOMAIN } = process.env

export const Hangouts = ({ location: { search }, user }) => {
  const { id } = useParams()
  const { room } = queryString.parse(search)
  const [userEntity, setUserEntity] = useState()
  const [urlToRedirect, setUrlToRedirect] = useState()

  const isChromeOS = /CrOS/.test(navigator.userAgent)

  useEffect(() => {
    let mounted = true
    const checkUserExternalReference = async () => {
      try {
        const response = await getMsApiToken()

        if (!response || response.data.errors) {
          setUserEntity(false)
          return
        }
        const newUserReference = await getUserExternalReference(response.data.authorization)

        if (mounted) {
          setUserEntity(newUserReference?.data)
        }
      } catch (e) {
        setUserEntity(false)
      }
    }

    checkUserExternalReference()
    return () => {
      mounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, room])

  useEffect(() => {
    if (userEntity) {
      const getRedirectURL = () => {
        if (!(id || room)) {
          return '/error?status=404'
        }

        const continueParam = id ? `https://meet.google.com/${id}` : `${room}`

        const userEmail = userEntity?.externalReference

        const userEmailDomain = userEmail.split('@')[1]
        const hangoutsUrl = `https://www.google.com/a/${userEmailDomain}/ServiceLogin?service=talk&continue=`
        const googleServiceLoginUrl = `${hangoutsUrl}${continueParam}?authuser=${userEmail}`

        const errorStatus = userEntity?.error?.response?.status

        const url = errorStatus === 500 ? continueParam : googleServiceLoginUrl
        return url
      }

      const url = getRedirectURL()

      setUrlToRedirect(url)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userEntity])

  const getUserExternalReference = async (msToken) => {
    const api = new Client({
      accept: 'application/json',
      apiURL: REACT_APP_MICROSERVICES_DOMAIN,
      accessToken: msToken,
    })
    const continueParam = id ? `https://meet.google.com/${id}` : room

    const newUserReference = await api.checkExternalReference(continueParam, user.id)
    return newUserReference
  }

  const proceedToHangouts = () => {
    window.location.href = urlToRedirect
  }

  if (userEntity === undefined) {
    return <Loading message='Estamos procurando a sua sala de aula' />
  }

  if (userEntity.results === 0) {
    return <Denied />
  }

  if (isChromeOS || Identifier.entityExists(userEntity?.externalReference)) {
    proceedToHangouts()
    return null
  }

  Identifier.setEntity(userEntity?.externalReference)

  return (
    <>
      <Loading message='Estamos direcionando você de forma segura para a sua aula digital' />
      <iframe
        allowFullScreen
        style={{ border: 'none' }}
        src='https://www.google.com/accounts/Logout'
        onLoad={proceedToHangouts}
        position='absolute'
        width='0'
        id={`hangouts-${id}`}
        height='0'
        title='Logout'
      />
    </>
  )
}

Hangouts.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  user: PropTypes.object,
}
